module.exports = __webpack_public_path__ + "img/equatorial-guinea.06c8f0e1.svg";